function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
import { jsx as _jsx } from "react/jsx-runtime";
import "/styles/global.scss";
import "styles/normalize.scss";
import "static/fonts/font.scss";
//import "@mondaydotcomorg/monday-ui-components/dist/main.css"; //For Dev env
import { collect } from "services/analytics/handlers/bigbrain-handler";
import { NEXTJS_WEB_VITAL_LABEL } from "constants/analytics";
import DatadogService from "services/datadog-service";
import { shouldExcludeMonitoring, shouldRemoveTrackers } from "utils/general";
const NEXT_HYDRATION_METRIC = "Next.js-hydration"; // for measure time to interaction
// Datadog
!shouldRemoveTrackers() && !shouldExcludeMonitoring() && DatadogService.init();
export function reportWebVitals(metric) {
    if (shouldRemoveTrackers()) return;
    if (metric.label && metric.label === NEXTJS_WEB_VITAL_LABEL) {
        collect(metric);
    }
    if (metric.name === NEXT_HYDRATION_METRIC) {
        collect(_object_spread_props(_object_spread({}, metric), {
            time: metric.startTime + metric.value
        }));
    }
}
export default function MyApp({ Component, pageProps }) {
    return /*#__PURE__*/ _jsx(Component, _object_spread({}, pageProps));
}
